'use client';

import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import DocumentSearchIcon from '@flipster/react/icon/generated/DocumentSearchIcon';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

import { filteredGlossaryTermsAtom } from '../jotai';

const NoSearchResult = () => {
  const filteredGlossaryTerms = useAtomValue(filteredGlossaryTermsAtom);
  if (filteredGlossaryTerms.length) return;

  return (
    <section
      className={vstack({ h: 240, justify: 'center', gap: 8, tablet: { h: 352 } })}
      role='alert'
      aria-live='polite'
    >
      <DocumentSearchIcon size={48} />
      <h2 className={css({ textStyle: 'Legacy/Body3', color: 'legacy.gray.d' })}>
        <FormattedMessage id='Autogen_common.r251126.s_No_available_keyword' />
      </h2>
    </section>
  );
};

export default NoSearchResult;
